import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function getStudentMeBuilder(apiClient: AxiosInstance) {
  return async function getStudentMe(): Promise<ICore.IStudentV4 | undefined> {
    const response = await apiClient.get("/v4/students/me/");
    return response.data;
  };
}
